import styled from "styled-components";
import { content } from "@glossy";

const KomonNavigationNavbar = styled.div`
  white-space: nowrap;
  cursor: pointer;
  color: ${content};
  &:hover {
    color: ${(props) => content(props, "secondary")};
  }
`;

export default KomonNavigationNavbar;
